(function() {
  'use strict';

  var WRAP_VARIANT_IDS = [43381122400315, 43516249636923];
  function isWrap(id) { return WRAP_VARIANT_IDS.indexOf(id) !== -1; }

  var syncing = false;
  var debounceTimer = null;
  var DEBOUNCE_MS = 120;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { return r.json(); });
  }

  function runSync() {
    if (syncing) return;
    syncing = true;

    fetchCart().then(function(cart) {
      var changes = [];

      cart.items.forEach(function(line) {
        if (!isWrap(line.variant_id)) return;
        if (!line.properties || !line.properties._gift_wrap_id) return;

        var pairingId = line.properties._gift_wrap_id;
        var parent = null;
        for (var i = 0; i < cart.items.length; i++) {
          var c = cart.items[i];
          if (isWrap(c.variant_id)) continue;
          if (c.properties && c.properties._gift_wrap_id === pairingId) { parent = c; break; }
        }

        if (!parent) {
          changes.push({ key: line.key, quantity: 0 });
        } else if (parent.quantity !== line.quantity) {
          changes.push({ key: line.key, quantity: parent.quantity });
        }
      });

      if (changes.length === 0) { syncing = false; return; }

      var chain = Promise.resolve();
      changes.forEach(function(c) {
        chain = chain.then(function() { return changeLine(c.key, c.quantity); });
      });

      chain.then(function() {
        syncing = false;
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { sections: {} } } }));
      }).catch(function(err) { syncing = false; console.error('[gift-wrap-sync]', err); });
    }).catch(function(err) { syncing = false; console.error('[gift-wrap-sync]', err); });
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { debounceTimer = null; runSync(); }, DEBOUNCE_MS);
  }

  document.addEventListener('cart:update', function() { if (!syncing) scheduleSync(); });

  var originalFetch = window.fetch;
  window.fetch = function(input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var promise = originalFetch.apply(this, arguments);
    if (isCartMutation && !syncing) { promise.then(function() { scheduleSync(); }).catch(function() {}); }
    return promise;
  };

  function init() { scheduleSync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
